// Bound Looplock page: buy box pickers, gallery, add to cart into the theme's drawer, sticky bar, colour tiles.
// gallery: the colour-blocked render first, then the pack and the macro of a locked loop in the colour picked, then the
// best stills (rice in the colour picked, chips and buns as shot)
const IMAGES = ['bl-hero-{c}', 'bl-pack-{c}', 'bl-lock-{c}', 'bl-chips', 'bl-rice-{c}', 'bl-dumpling'];
const ALTS = ['{c} Looplocks with their 8-pack: six laid flat and two locked in a loop',
  'The front and back of the {c} Looplock 8-pack: roll, loop, lock',
  'Close-up of a {c} Looplock locked in a loop, the bound tab clicked into its slot',
  'Half a bag of potato chips with the top rolled down and held by a Blueberry Looplock',
  'A bag of basmati rice on a kitchen bench, sealed with a {c} Looplock',
  'A bag of steamed buns rolled shut with a Blueberry Looplock, next to a bun on a plate'];
const STICKY = 'bl-white-{c}';

// format cents the way the store's own money filter does, read off a sample it rendered ("$1,234.56")
function moneyFormatter(sample) {
  const m = /1(\D?)234(?:(\D)(\d{2}))?/.exec(sample || '');
  if (!m) return (c) => '$' + (c / 100).toFixed(2);
  const [whole, thou, dec] = m;
  const pre = sample.slice(0, m.index);
  const post = sample.slice(m.index + whole.length);
  return (cents) => {
    const n = Math.round(Number(cents) || 0);
    const units = dec ? (n / 100).toFixed(2).split('.') : [String(Math.round(n / 100))];
    units[0] = units[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return pre + units.join(dec || '') + post;
  };
}


function initBuy(root) {
  if (root.dataset.blReady) return;
  root.dataset.blReady = '1';
  const data = JSON.parse(root.querySelector('[data-bl-data]').textContent);
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.from(root.querySelectorAll(s));
  const form = $('[data-bl-form]');
  const kit = !!data.kit;
  const hasPack = data.packIndex >= 0;
  const money = moneyFormatter(data.moneySample);
  const singles = data.singles || [];
  const singleFor = (colour) => singles.find((s) => s.colour === colour);
  const state = {
    colour: $('.bl-swatch[data-bl-colour][aria-checked="true"]')?.dataset.blColour,
    pack: $('.bl-pack[data-bl-pack][aria-checked="true"]')?.dataset.blPack,
    image: 0,
    // kit mode: how many packs (1, 2 or 4) and the colour of each, as the page was drawn
    n: Number($('.bl-pack[data-bl-bundle][aria-checked="true"]')?.dataset.blBundle) || 2,
    slots: [0, 1, 2, 3].map((i) => $(`[data-bl-slot="${i}"] [aria-checked="true"]`)?.dataset.blSlotColour || null),
  };
  // the gallery shows the colour last picked
  state.show = kit ? state.slots[0] : state.colour;
  const pct = Number(data.pct) || 0;
  const priced = (cents, n) => Math.round(cents * (n >= 4 ? (100 - pct) / 100 : 1));
  const fullFor = (n) => state.slots.slice(0, n).reduce((a, c) => a + (singleFor(c)?.cents || 0), 0);

  const variantFor = (colour, pack) =>
    data.variants.find((v) => v.colour === colour && (!hasPack || v.pack === pack));
  const keyFor = (colour) => (colour || '').split('&')[0].trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
  const rendered = data.rendered || [];
  // colours without their own renders (a new colourway) use the variant's own image first, then the stand-in colour
  const img = (i, size, name = IMAGES[i], colour = state.show) => {
    let key = keyFor(colour);
    if (name.includes('{c}') && rendered.length && !rendered.includes(key)) {
      const v = kit ? null : (variantFor(colour, state.pack) || data.variants.find((x) => x.colour === colour));
      if (i === 0 && v && v.image) return v.image;
      key = rendered[0];
    }
    return data.assetBase + name.replace('{c}', key) + '-' + size + '.jpg';
  };

  function renderGallery() {
    const main = $('[data-bl-main]');
    main.src = img(state.image, 1600);
    main.srcset = img(state.image, 800) + ' 800w, ' + img(state.image, 1600) + ' 1600w';
    main.alt = ALTS[state.image].replace('{c}', state.show || '');
    $$('.bl-gallery__thumbs [data-bl-thumb]').forEach((b) => {
      b.querySelector('img').src = img(Number(b.dataset.blThumb), 800);
    });
    $$('[data-bl-thumb]').forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.blThumb) === state.image)));
  }

  function renderKit() {
    const n = state.n;
    const chosen = state.slots.slice(0, n);
    const picked = chosen.map(singleFor);
    const full = fullFor(n);
    const total = priced(full, n);
    const ok = picked.every((x) => x && x.available);

    $$('.bl-pack[data-bl-bundle]').forEach((b) => {
      const sz = Number(b.dataset.blBundle);
      b.setAttribute('aria-checked', String(sz === n));
      const f = fullFor(sz);
      const p = priced(f, sz);
      b.querySelector('[data-bl-bundle-price]').textContent = money(p);
      b.querySelector('[data-bl-bundle-was]').textContent = p < f ? money(f) : '';
      b.querySelector('[data-bl-bundle-each]').textContent = money(Math.round(p / (8 * sz))) + ' per Looplock™';
    });

    const slotsBox = $('[data-bl-slots]');
    if (slotsBox) slotsBox.dataset.n = String(n);
    $$('[data-bl-slot-row]').forEach((row) => { row.hidden = Number(row.dataset.blSlotRow) >= n; });
    $$('[data-bl-slot-colour]').forEach((b) => {
      const i = Number(b.dataset.blSlotIndex);
      b.setAttribute('aria-checked', String(state.slots[i] === b.dataset.blSlotColour));
      const x = singleFor(b.dataset.blSlotColour);
      b.dataset.unavailable = String(!(x && x.available));
    });
    $$('[data-bl-slot-name]').forEach((el, i) => { el.textContent = state.slots[i] || ''; });
    $$('[data-bl-slot-thumb]').forEach((el, i) => {
      const src = img(2, 800, IMAGES[2], state.slots[i]);
      if (el.getAttribute('src') !== src) {
        el.src = src;
        if (el.animate) el.animate([{ opacity: 0.2, transform: 'scale(.9)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 220, easing: 'ease-out' });
      }
    });
    const title = $('[data-bl-colours-title]');
    if (title) title.textContent = n === 1 ? 'Choose your colour' : 'Choose your colours';
    const aside = $('[data-bl-colours-aside]');
    if (aside) {
      if (aside.dataset.text === undefined) aside.dataset.text = aside.textContent || 'Mix them any way you like';
      aside.textContent = n > 1 ? aside.dataset.text : '';
    }

    // the form and express checkout buy one variant at a time, so they only run when every pack is one colour
    const same = chosen.every((c) => c === chosen[0]);
    const first = picked[0];
    $('[data-bl-id]').value = first ? first.id : '';
    $('[data-bl-qty]').value = n;
    const express = form.querySelector('.shopify-payment-button, [data-shopify="payment-button"]');
    if (express) express.style.display = same && ok ? '' : 'none';
    const atc = $('[data-bl-atc]');
    atc.disabled = !ok;
    $('[data-bl-atc-text]').textContent = ok ? 'Add to cart · ' + money(total) : 'A colour you picked is sold out';
    const nudge = $('[data-bl-nudge]');
    if (nudge) nudge.textContent = n >= 2 ? data.nudgeMulti : data.nudgeSingle;

    const bundle = $('.bl-pack[data-bl-bundle][aria-checked="true"]');
    const colours = Array.from(new Set(chosen)).join(', ');
    const sLine = $('[data-bl-sticky-line]');
    if (sLine) sLine.textContent = [bundle?.dataset.blBundleTitle, colours].filter(Boolean).join(' · ');
    const sPrice = $('[data-bl-sticky-price]');
    if (sPrice) sPrice.textContent = money(total);
    const sImg = $('[data-bl-sticky-img]');
    if (sImg) sImg.src = img(-1, 800, STICKY, chosen[0]);
    if (first && (document.querySelector('main')?.dataset.template || '').startsWith('product')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', first.id);
      window.history.replaceState({}, '', url);
    }
  }

  function renderVariants() {
    const v = variantFor(state.colour, state.pack);
    $$('.bl-swatch[data-bl-colour]').forEach((b) => {
      b.setAttribute('aria-checked', String(b.dataset.blColour === state.colour));
      const any = data.variants.some((x) => x.colour === b.dataset.blColour && x.available);
      b.dataset.unavailable = String(!any);
    });
    $$('.bl-pack[data-bl-pack]').forEach((b) => {
      const pv = variantFor(state.colour, b.dataset.blPack);
      b.setAttribute('aria-checked', String(b.dataset.blPack === state.pack));
      b.querySelector('[data-bl-pack-price]').textContent = pv ? pv.price : '';
      const detail = [];
      if (pv) {
        detail.push(pv.seals + ' Looplocks');
        detail.push(pv.each + ' per Looplock™');
        if (!pv.available) detail.push('sold out');
      } else {
        detail.push('not in this colour');
      }
      b.querySelector('[data-bl-detail]').textContent = detail.join(' · ');
      const badge = b.querySelector('[data-bl-badge]');
      if (pv && pv.saving && !badge.dataset.fixed) badge.textContent = 'Save ' + pv.saving;
      b.disabled = !pv;
    });
    const name = $('[data-bl-colour-name]');
    if (name) name.textContent = state.colour || '';
    const id = $('[data-bl-id]');
    const atc = $('[data-bl-atc]');
    const atcText = $('[data-bl-atc-text]');
    const qty = $('[data-bl-qty]');
    if (v) {
      id.value = v.id;
      if (qty) qty.value = v.qty || 1;
      atc.disabled = !v.available;
      atcText.textContent = v.available ? 'Add to cart · ' + v.price : 'Sold out';
    } else {
      atc.disabled = true;
      atcText.textContent = 'Not available in this colour';
    }
    const nudge = $('[data-bl-nudge]');
    if (nudge) nudge.textContent = v && v.freeShip ? data.nudgeMulti : data.nudgeSingle;
    const sLine = $('[data-bl-sticky-line]');
    const packTitle = $('.bl-pack[data-bl-pack][aria-checked="true"]')?.dataset.blPackTitle || state.pack;
    if (sLine) sLine.textContent = [state.colour, packTitle].filter(Boolean).join(' · ');
    const sPrice = $('[data-bl-sticky-price]');
    if (sPrice && v) sPrice.textContent = v.price;
    const sImg = $('[data-bl-sticky-img]');
    if (sImg) sImg.src = img(-1, 800, STICKY);
    // keep the address bar on the chosen variant, so a shared link opens the same choice
    if (v && (document.querySelector('main')?.dataset.template || '').startsWith('product')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
  }

  function render() {
    if (kit) renderKit(); else renderVariants();
    renderGallery();
  }

  // badges set in the theme editor stay as written
  $$('[data-bl-badge]').forEach((b) => { if (b.textContent.trim()) b.dataset.fixed = '1'; });

  root.addEventListener('click', (e) => {
    const slot = e.target.closest('[data-bl-slot-colour]');
    if (slot) {
      state.slots[Number(slot.dataset.blSlotIndex)] = slot.dataset.blSlotColour;
      state.show = slot.dataset.blSlotColour;
      render();
      return;
    }
    const sw = e.target.closest('.bl-swatch[data-bl-colour]');
    if (sw) { state.colour = state.show = sw.dataset.blColour; state.image = 0; render(); return; }
    const bundle = e.target.closest('[data-bl-bundle]');
    if (bundle) { state.n = Number(bundle.dataset.blBundle); render(); return; }
    const pk = e.target.closest('.bl-pack[data-bl-pack]');
    if (pk && !pk.disabled) { state.pack = pk.dataset.blPack; render(); return; }
    const th = e.target.closest('[data-bl-thumb]');
    if (th) { state.image = Number(th.dataset.blThumb); render(); }
  });

  // swipe the main image on phones
  let x0 = null;
  const mainBox = $('.bl-gallery__main');
  mainBox.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
  mainBox.addEventListener('touchend', (e) => {
    if (x0 === null) return;
    const dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) < 40) return;
    state.image = (state.image + (dx < 0 ? 1 : IMAGES.length - 1)) % IMAGES.length;
    render();
  });

  // add to cart through the theme's own cart drawer
  const err = $('[data-bl-error]');
  const cartSections = () => Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId).filter(Boolean);
  const addUrl = () => (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

  async function post(items, button, errBox) {
    button.setAttribute('aria-busy', 'true');
    errBox.textContent = '';
    const body = { items };
    const sections = cartSections();
    if (sections.length) body.sections = sections.join(',');
    try {
      const res = await fetch(addUrl(), {
        method: 'POST', body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const json = await res.json();
      if (json.status) { errBox.textContent = json.description || json.message || 'That did not add. Please try again.'; return false; }
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(new CartAddEvent({}, String(items[0].id), {
          source: 'bl-buy', itemCount: items.reduce((a, x) => a + x.quantity, 0), productId: String(data.productId), sections: json.sections,
        }));
      } catch (e) {
        window.location.href = '/cart';
      }
      return true;
    } catch (e) {
      errBox.textContent = 'That did not add. Please try again.';
      return false;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  async function add() {
    const atc = $('[data-bl-atc]');
    if (atc.disabled) return;
    if (kit) {
      // one line per colour: two Mango and two Kiwi go in as 2 x Mango 8-pack and 2 x Kiwi 8-pack
      const counts = new Map();
      state.slots.slice(0, state.n).forEach((c) => counts.set(c, (counts.get(c) || 0) + 1));
      await post(Array.from(counts, ([c, q]) => ({ id: singleFor(c).id, quantity: q })), atc, err);
      return;
    }
    const fd = new FormData(form);
    await post([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }], atc, err);
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); add(); });

  // sticky bar once the buy box is out of view
  const sticky = $('[data-bl-sticky]');
  if (sticky) {
    const sBtn = sticky.querySelector('[data-bl-sticky-atc]');
    sBtn.addEventListener('click', add);
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.dataset.visible = String(show);
      sticky.setAttribute('aria-hidden', String(!show));
      sBtn.tabIndex = show ? 0 : -1;
    });
    io.observe(form);
  }

  // colour tiles and the Kitchen Pack button elsewhere on the page drive this box
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-bl-pick-colour], [data-bl-pick-pack]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    if (t.dataset.blPickColour) {
      if (kit) {
        if (singleFor(t.dataset.blPickColour)) { state.slots[0] = state.show = t.dataset.blPickColour; state.image = 0; }
      } else {
        const match = data.variants.find((v) => v.colour === t.dataset.blPickColour);
        if (match) { state.colour = state.show = match.colour; state.image = 0; }
      }
    }
    if (t.dataset.blPickPack) {
      const n = Number(t.dataset.blPickPack);
      if (kit) {
        state.n = [1, 2, 4][Math.min(n, 2)];
      } else if (hasPack) {
        const want = $$('.bl-pack[data-bl-pack]').map((b) => b.dataset.blPack)[n];
        if (want) state.pack = want;
      }
    }
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  render();
}

document.querySelectorAll('[data-bl-buy]').forEach(initBuy);
document.addEventListener('shopify:section:load', (e) => {
  const el = e.target.querySelector('[data-bl-buy]');
  if (el) initBuy(el);
});
